// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"ea5953893eba69eace20","873":"3490c79c9b4c7f63354c"}[chunkId] + ".js";
};